import { ANONYMOUS_USER_ID } from '../../constants/tempData/tempData.contant';
import { IUserTempData, IUserTempDataMap } from '../../interfaces/Element.interfaces';
import { browserStorage } from '../browserStorage.util';
import { formatJSONStringToMap } from '../formatter/formatJSONStringToMap.util';

interface IGetUserTempDataMapFromStorageReturn {
  userTempDataMap: IUserTempDataMap;
}

export const getUserTempDataMapFromStorage = (): IGetUserTempDataMapFromStorageReturn => {
  const storedData = browserStorage.getItem({
    storageType: 'localStorage',
    itemKey: 'userTempData',
  });
  const userTempDataMap: IUserTempDataMap = storedData ? formatJSONStringToMap(storedData) : new Map<string, string>();
  return { userTempDataMap };
};

interface IGetUserTempDataReturn {
  userTempData: IUserTempData;
}

export const getUserTempData = (userId?: string): IGetUserTempDataReturn => {
  const { userTempDataMap } = getUserTempDataMapFromStorage();

  const userTempData = userTempDataMap.get(userId ?? ANONYMOUS_USER_ID);

  if (!userTempData) {
    return { userTempData: new Map<string, string>() };
  }

  return { userTempData: formatJSONStringToMap(userTempData) };
};
